import { DatePicker, Input, Select, Textarea } from '@chilecompra/react-kit/components'
import { addYears, endOfYear, startOfYear, subYears } from 'date-fns'
import PropTypes from 'prop-types'

import { Container, Item } from '../../Cfmp.styles'
import { inputShape, selectFieldShape } from './CfmpForm.propTypes'

/**
 * The CfmpFormGeneralInformation component.
 */
export const CfmpFormGeneralInformation = ({
  contractEndDate,
  contractStartDate,
  currency,
  isDisabled = false,
  isSourcesLoading = false,
  purchaseReason,
  totalAmount
}) => {
  return (
    <Container direction="column">
      <Item size={12}>
        <Textarea
          disabled={isDisabled}
          error={purchaseReason.error}
          label="Motivo"
          loading={isSourcesLoading}
          maxCount={500}
          maxLength={500}
          minRows={8}
          onChange={purchaseReason.onChange}
          value={purchaseReason.value}
        />
      </Item>

      <Item container size={12} spacing={2}>
        <Item size={{ md: 6, xs: 12 }}>
          <DatePicker
            disabled={isDisabled}
            error={contractStartDate.error}
            format="dd/MM/yyyy"
            label="Fecha de inicio del contrato"
            loading={isSourcesLoading}
            localeText={{
              fieldYearPlaceholder: params => 'A'.repeat(params.digitAmount)
            }}
            maxDate={endOfYear(addYears(new Date(), 5))}
            minDate={startOfYear(subYears(new Date(), 25))}
            onChange={contractStartDate.onChange}
            value={contractStartDate.value}
          />
        </Item>

        <Item size={{ md: 6, xs: 12 }}>
          <DatePicker
            disabled={isDisabled}
            error={contractEndDate.error}
            format="dd/MM/yyyy"
            label="Fecha de término del contrato"
            loading={isSourcesLoading}
            localeText={{
              fieldYearPlaceholder: params => 'A'.repeat(params.digitAmount)
            }}
            maxDate={endOfYear(addYears(new Date(), 5))}
            minDate={
              contractStartDate.value
                ? contractStartDate.value
                : startOfYear(subYears(new Date(), 25))
            }
            onChange={contractEndDate.onChange}
            value={contractEndDate.value}
          />
        </Item>
      </Item>

      <Item container size={12} spacing={2}>
        <Item size={{ md: 5, xs: 12 }}>
          <Select
            disabled={Boolean(currency.source.error) || isDisabled}
            error={currency.errorText}
            label="Tipo de moneda"
            loading={isSourcesLoading}
            onChange={currency.input.onChange}
            options={currency.source.data}
            placeholder={
              currency.source.error
                ? 'Sin tipo de moneda disponible'
                : 'Seleccione un tipo de moneda...'
            }
            value={currency.input.value}
          />
        </Item>

        <Item size={{ md: 7, xs: 12 }}>
          <Input
            disabled={isDisabled || !currency.input.value}
            error={totalAmount.error}
            label="Monto total"
            loading={isSourcesLoading}
            maxLength={20}
            onChange={totalAmount.onChange}
            value={totalAmount.value}
          />
        </Item>
      </Item>
    </Container>
  )
}

CfmpFormGeneralInformation.propTypes = {
  contractEndDate: inputShape.isRequired,
  contractStartDate: inputShape.isRequired,
  currency: selectFieldShape.isRequired,
  isDisabled: PropTypes.bool,
  isSourcesLoading: PropTypes.bool,
  purchaseReason: inputShape.isRequired,
  totalAmount: inputShape.isRequired
}
